import React from 'react';
import { useSelector } from 'react-redux';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { BiRocket as GetStartedIcon } from 'react-icons/bi';
import CommunicationIcon from '@material-ui/icons/Message';
import BackgroundChecksIcon from '@material-ui/icons/HowToReg';
import ProgramsIcon from '@material-ui/icons/CreditCard';
import SubscriptionIcon from '@material-ui/icons/LockOpen';
import HelpIcon from '@material-ui/icons/Help';
import OtherIcon from '@material-ui/icons/MoreHoriz';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import SettingsIcon from '@material-ui/icons/Settings';
import { ThemeProvider } from '@material-ui/core/styles';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import Hidden from '@material-ui/core/Hidden';
import appDuck from '../redux/modules/appDuck';
import NewAnnouncementDialog from 'appDir/components/Shared/NewAnnouncementDialog';
import ContactsIcon from '@material-ui/icons/People';
import WebIcon from '@material-ui/icons/ImportantDevices';
import { useMutation, gql } from '@apollo/client';
import { toastServerError } from 'appDir/lib/functions/toastError';
import { CircularLoading } from 'appDir/lib/components/Loading';
import SignOutIcon from '@material-ui/icons/ExitToApp';
// import GettingStartedRoot from 'appDir/components/Shared/GettingStarted/GettingStartedRoot';
// import useGettingStartedMode from 'appDir/lib/hooks/useGettingStartedMode';

const SIGN_OUT_USER = gql`
  mutation SignOutUser {
    signOutUser {
      userId
    }
  }
`;

const defaultTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#1565c0',
    },
  },
});

const BottomNavigationContainerWrapped = () => {
  const currentUser = useSelector(appDuck.selectors.currentUser);
  const currentOrganization = useSelector(
    appDuck.selectors.currentOrganization
  );
  const [otherDialogOpen, setOtherDialogOpen] = React.useState(false);
  const [
    newAnnouncementDialogOpen,
    setNewAnnouncementDialogOpen,
  ] = React.useState(false);
  const [signOutUser, { signOutUserLoading }] = useMutation(SIGN_OUT_USER, {
    onError: toastServerError,
    onCompleted: () => {
      window.location.href = '/';
    },
  });
  // const { gettingStartedMode } = useGettingStartedMode();
  React.useEffect(() => {
    const { email } = currentUser.attributes;
    if (window.Beacon) {
      window.Beacon('prefill', {
        // name,
        email,
        subject: `${currentOrganization.attributes.name}: Help`,
      });
    }
  });
  //HOOKS END

  const {
    hasSubscription,
    showGettingStarted,
  } = currentOrganization.attributes;

  const handleSignOutClick = () => {
    signOutUser();
  };

  return (
    <Hidden mdUp>
      {/* <style>{`
        iframe#drift-widget {
          bottom: 56px !important;
          right: 8px !important;
        }
      `}</style> */}
      <ThemeProvider theme={defaultTheme}>
        <BottomNavigation
          value={window.location.pathname}
          showLabels
          onChange={(event, value) => {
            if (value === 'other') setOtherDialogOpen(true);
          }}
          style={{ width: '100%', position: 'fixed', bottom: 0, top: 'auto' }}
        >
          {showGettingStarted ? (
            <BottomNavigationAction
              component="a"
              href="/admin/getting_started"
              value="/admin/getting_started"
              label="Get&nbsp;Started"
              icon={<GetStartedIcon style={{ width: 24, height: 24 }} />}
            />
          ) : (
            <BottomNavigationAction
              component="a"
              href="/admin/dashboard"
              value="/admin/dashboard"
              label="Dashboard"
              icon={<DashboardIcon />}
            />
          )}
          <BottomNavigationAction
            component="a"
            href="/?ep_mode=edit"
            value="/"
            label="Website Builder"
            icon={<WebIcon />}
          />
          <BottomNavigationAction
            component="a"
            href="/admin/programs"
            value="/admin/programs"
            label="Registration"
            icon={<ProgramsIcon />}
          />
          <BottomNavigationAction
            value="other"
            label="More"
            icon={<OtherIcon />}
          />
        </BottomNavigation>
        <Dialog
          open={otherDialogOpen}
          onClose={() => setOtherDialogOpen(false)}
        >
          <List>
            {!hasSubscription && (
              <ListItem
                component="a"
                href="/admin/subscription/new"
                button
                style={{ backgroundColor: '#2096F3' }}
              >
                <ListItemIcon style={{ color: '#fff' }}>
                  <SubscriptionIcon />
                </ListItemIcon>
                <ListItemText style={{ color: '#fff' }}>
                  Select A Plan
                </ListItemText>
              </ListItem>
            )}
            {!hasSubscription && (
              <ListItem component="a" href="/admin/programs" button>
                <ListItemIcon>
                  <ProgramsIcon />
                </ListItemIcon>
                <ListItemText>Programs</ListItemText>
              </ListItem>
            )}
            <ListItem component="a" href="/admin/contacts" button>
              <ListItemIcon>
                <ContactsIcon />
              </ListItemIcon>
              <ListItemText>Contact Manager</ListItemText>
            </ListItem>
            <React.Fragment>
              <ListItem
                component="button"
                onClick={() => setNewAnnouncementDialogOpen(true)}
                button
              >
                <ListItemIcon>
                  <CommunicationIcon />
                </ListItemIcon>
                <ListItemText>Send Announcement</ListItemText>
              </ListItem>
              <NewAnnouncementDialog
                open={newAnnouncementDialogOpen}
                onClose={() => setNewAnnouncementDialogOpen(false)}
              />
            </React.Fragment>
            <ListItem component="a" href="/admin/background_checks" button>
              <ListItemIcon>
                <BackgroundChecksIcon />
              </ListItemIcon>
              <ListItemText>Background Checks</ListItemText>
            </ListItem>
            {/*<ListItem component="a" href="/admin/updates">*/}
            {/*  <ListItemIcon>*/}
            {/*    <ProgramsIcon />*/}
            {/*  </ListItemIcon>*/}
            {/*  <ListItemText>Updates</ListItemText>*/}
            {/*</ListItem>*/}
            {/*<ListItem component="a" href="/admin/contacts">*/}
            {/*  <ListItemIcon>*/}
            {/*    <ContactsIcon />*/}
            {/*  </ListItemIcon>*/}
            {/*  <ListItemText>Contacts</ListItemText>*/}
            {/*</ListItem>*/}
            <ListItem component="a" href="/admin/settings" button>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText>Settings</ListItemText>
            </ListItem>
            <ListItem
              button
              onClick={() => {
                setOtherDialogOpen(false);
                window.Beacon('open');
                // gettingStartedMode
                //   ? window.drift.on('ready', (api) => {
                //       api.sidebar.open();
                //     })
                //   : window.Beacon('open');
              }}
            >
              <ListItemIcon>
                <HelpIcon />
              </ListItemIcon>
              <ListItemText>Help / Feedback</ListItemText>
            </ListItem>
            <ListItem button onClick={handleSignOutClick}>
              <ListItemIcon>
                <SignOutIcon />
              </ListItemIcon>
              <ListItemText>Sign Out</ListItemText>
            </ListItem>
          </List>
        </Dialog>
        {signOutUserLoading && <CircularLoading />}
      </ThemeProvider>
      {/*<GettingStartedRoot />*/}
    </Hidden>
  );
};

const BottomNavigationContainer = props => {
  const canEditOrganization = useSelector(
    appDuck.selectors.canEditOrganization
  );
  if (!canEditOrganization) return null;
  return <BottomNavigationContainerWrapped {...props} />;
};

export default BottomNavigationContainer;
